// Component to render the profile card
// Import react
import React, { useState, useEffect } from "react";

// Import supabase configuration
import supabase from "../../config/supabase";
import { useRef } from "react";
// Import button
import { Buffer } from "buffer";
import Button from "../../components/button/button";

export default function Profile({
  profile,
  showModal,
  setProfileid,
  setValue,
  showNewModal,
  proccessed=false,
  justView = true,
}) {

  const [url, setUrl] = useState("/blurry.svg");
  const [name, setName] = useState("");
  const [skills, setSkills] = useState([]);

  const acceptedRef = useRef(null);

  const [dateTimePicker, setDateTimePicker] = useState([]);

  const handleChange = (newValue) => {
    setDateTimePicker(newValue);
  };

  useEffect(async () => {
    var name = profile.full_name && profile.full_name.split(" ");
    name =
      name.length > 1
        ? name[0][0].toUpperCase() + name[1][0].toUpperCase()
        : name[0][0].toUpperCase();
    setName(name);

    // if dp is available
    if (profile && profile.dp) {
      // get url for dp
      const { signedUrl, data, error } = await supabase.storage
        .from("data")
        .createSignedUrl(profile.dp, 600);
      if (data) {
        // set url
        setUrl(data["signedURL"]);
      }
    }

    var primarySkills = [];
		primarySkills = (profile && profile.skill_level.length > 0) && profile.skill_level.map(element => {
			return element.skill.toLowerCase().trim();
		  });

		// Set skills
		setSkills(primarySkills);
  }, []);

  const handleClose = (value) => {
    setProfileid(profile.id);
    if (value == "Accepted") {
      setValue(value);
      showNewModal(true);
    } else {
      showModal(true);
      setValue(value);
    }
  };

  const viewProfile = () => {
    window.open(
      `${window.location.origin}/profile?id=${Buffer.from(
        profile.id,
        "utf8"
      ).toString("base64")}&client=true`,
      "_blank"
    );
  };

  return (
    // Function to render the content
    <div className="w-full h-auto relative container cursor-pointer">
      {/* Status buttons */}
      {
        !justView && <div className="col-span-12 mt-1 ">
          { 
          proccessed ? profile.status == "Hold" ? <div className="col-span-12 grid grid-cols-12 gap-3">
            {/* Show buttons */}
            <div className="col-span-9 flex space-x-2 space-between absolute top-2 left-2 more">
              <div className="">
                <Button buttonType="tag" value="Accepted" className={`bg-green-1`} onClick={() => handleClose("Accepted")} />
              </div>
              <div className="">
                <Button buttonType="tag" value="Rejected" className={`bg-red-1`} onClick={() => handleClose("Rejected")} />
              </div>
            </div>

            {/* Show status */}
            <div className="col-span-3 absolute top-2 right-2 z-10">
              <Button buttonType="tag" value={profile.status} className={`w-auto cursor-text ${profile.status == "Hold" ? " bg-blue-1" : profile.status == "Accepted" ? "bg-green-1" : profile.status == "Rejected" ? "bg-red-1" : "bg-grey-1"} border-2`} />
            </div>

          </div> : 
          <div className="col-span-12 absolute top-2 right-2 z-10">
          <Button buttonType="tag" value={profile.status} className={`w-auto cursor-text ${profile.status == "Hold" ? " bg-blue-1" : profile.status == "Accepted" ? "bg-green-1" : profile.status == "Rejected" ? "bg-red-1" : "bg-grey-1"} border-2`} />
          </div>
          :
          <div className="col-span-12 flex space-x-2 space-between overflow-hidden absolute top-2 left-2 more">
          <div className="">
            <Button buttonType="tag" value="Hold" className={`bg-blue-1`} onClick={() => handleClose("Hold")}/>
          </div>
          <div className="">
            <Button buttonType="tag" value="Accepted" className={`bg-green-1`} onClick={() => handleClose("Accepted")} />
          </div>
          <div className="">
            <Button buttonType="tag" value="Rejected" className={`bg-red-1`} onClick={() => handleClose("Rejected")} />
          </div>
          </div>
          }
          </div>
      }
     
      {/* Add card */}
      <div
        className="rounded-lg bg-grey-2 shadow-md h-auto grid grid-cols-12 gap-0 p-6 box-border hover:opacity-50 card"
        onClick={() => viewProfile()}
      >
        {/* Column for avatar */}
        <div className="col-span-12 flex items-center justify-center relative mt-7">
          {/* Render image if provided */}
          {profile.dp ? (
            // Render imgae
            <img className="object-cove w-24 h-24 rounded-full" src={url} />
          ) : (
            // Render placeholder
            <div className="w-24 h-24 bg-white-3 flex items-center rounded-full">
              {/* Render text */}
              <div className="text-center w-full text-md font-text text-white-1 font-medium">
                {profile.full_name && profile.full_name[0].toUpperCase()}
              </div>
            </div>
          )}
        </div>

        {/* Render name */}
        <div className="w-full text-sm mt-2 font-text text-black-1 font-bold col-span-12 flex justify-center">
            {name}
        </div>

        <div className="col-span-12 grid grid-cols-12 gap-1 mt-3">
          {/* Column for location and timezone */}
          <div className="col-span-9 xl-1:col-span-7 grid grid-cols-12 gap-x-3 text-xs font-text text-black-1">
            {/* Add space */}
            <div className="col-span-2 xl-1:col-span-2 xl-2:col-span-3"></div>
            {/* Add data */}
            <div className="col-span-10 xl-1:col-span-9 grid grid-cols-12 gap-x-3">
              <div className="col-span-12">
                {
                    profile.location &&  <div className="flex" >
                      <svg className="h-3 w-3 fill-current text-black-1 mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 14v2a6 6 0 0 0-6 6H4a8 8 0 0 1 8-8zm0-1c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm8.828 10.071L18 24l-2.828-2.929c-1.563-1.618-1.563-4.24 0-5.858a3.904 3.904 0 0 1 5.656 0c1.563 1.618 1.563 4.24 0 5.858zm-1.438-1.39c.813-.842.813-2.236 0-3.078a1.904 1.904 0 0 0-2.78 0c-.813.842-.813 2.236 0 3.079L18 21.12l1.39-1.44z"/></svg>
                      {profile.location}
                  </div>
                }
              </div>

              <div className="col-span-12">
                {
                    profile.timezone &&  <div className="flex" >
                    <svg className="h-4 w-4 fill-current text-black-1 mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-2.29-2.333A17.9 17.9 0 0 1 8.027 13H4.062a8.008 8.008 0 0 0 5.648 6.667zM10.03 13c.151 2.439.848 4.73 1.97 6.752A15.905 15.905 0 0 0 13.97 13h-3.94zm9.908 0h-3.965a17.9 17.9 0 0 1-1.683 6.667A8.008 8.008 0 0 0 19.938 13zM4.062 11h3.965A17.9 17.9 0 0 1 9.71 4.333 8.008 8.008 0 0 0 4.062 11zm5.969 0h3.938A15.905 15.905 0 0 0 12 4.248 15.905 15.905 0 0 0 10.03 11zm4.259-6.667A17.9 17.9 0 0 1 15.973 11h3.965a8.008 8.008 0 0 0-5.648-6.667z"/></svg>                    
                    {profile.timezone.split(" ")[0]}
                  </div>
                }
              </div>
            </div>
            
          </div>
          
          <div className="col-span-3 xl-1:col-span-5 grid grid-cols-12 gap-x-3 text-xs font-text text-black-1 flex justify-center">
            <div className="col-span-12">
              {/* Render exp */}
              {profile.exp ? (
                <div
                  className={`w-full mb-2 items-center flex`}
                >
                  {/* Icon */}
                  <svg
                    className="h-3 w-3 fill-current text-black-1 mr-1 mb-1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                  >
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm1-8h4v2h-6V7h2v5z" />
                  </svg>
                  {/* Text */}
                  {profile.exp} Years
                </div>
              ) : null}

            </div>
           
            <div className="col-span-12 flex">
              {/* Render contract status */}
              {profile.contract_status ? (
                <div className={`w-full mb-2 items-center flex`}>
                  {/* Icon */}
                  <svg className="h-3 w-3 fill-current text-black-1 mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M17 3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1h2v2h6V1h2v2zm-2 2H9v2H7V5H4v4h16V5h-3v2h-2V5zm5 6H4v8h16v-8z"/></svg>
                  {/* Text */}
                  {profile.contract_status}
                </div>
              ) : null}

            </div>
          </div>
            
        </div>
        
        {/* Show skills */}
				<div className="col-span-12 flex flex-wrap justify-center mt-2">

          {/* Render tags */}
          {
            skills.length > 3 ? <div className="flex">{
            skills.slice(0,3).map( (skill, index) => <div key={index} className={`border-white-3 text-black-1 text-xs p-0.5 mr-2 mb-2 rounded-sm bg-grey-2 border font-text whitespace-nowrap`} >{skill}</div>
            ) } +{skills.length - 3} </div>
            :
            skills.length <= 0 ? null :
            skills.map( (skill, index) => <div key={index} className={`border-white-3 text-black-1 text-xs p-0.5 mr-2 mb-2 rounded-sm bg-grey-2 border font-text whitespace-nowrap`} >{skill}</div>) 					
          }
        </div>
      </div>
    </div>
  );
}
